import React from 'react'
import { useSelector } from 'react-redux'

import SocialReturnOnInvestment from './SocialReturnOnInvestment'
import SocialReturnOnInvestmentOld from './SocialReturnOnInvestmentOld'

import { selectedPartnershipSelector } from '../../modules/selectors/partnerships'

const SocialReturnOnInvestmentWrapper = () => {
  const selectedPartnership = useSelector(selectedPartnershipSelector)
  const deepDive = selectedPartnership.sroi?.deep_dive

  if (deepDive) {
    return <SocialReturnOnInvestment />
  } else {
    return <SocialReturnOnInvestmentOld />
  }
}

export default SocialReturnOnInvestmentWrapper
